module.exports = __webpack_public_path__ + "img/20190803105451690.f06ae122.png";